import Vue from 'vue';
import RecaptchaWrapper from './recaptcha-wrapper';
import Box from './box';
import Modal from './modal';
import ModalConfirmation from './modal-confirmation';
import ModalRoles from './modal-roles';
import CopyToClipboard from './copy-to-clipboard';
import Chat from './chat/chat';
import Hamburger from './hamburger';
import SoundToggle from './sound-toggle';
import PasswordInput from './password-input';
import PayPalDonation from './paypal-donation';
import PlayerAvatar from './player-avatar';
import TeamVote from './team-vote';

Vue.component('avl-recaptcha-wrapper', RecaptchaWrapper);
Vue.component('avl-box', Box);
Vue.component('avl-modal', Modal);
Vue.component('avl-modal-confirmation', ModalConfirmation);
Vue.component('avl-modal-roles', ModalRoles);
Vue.component('avl-copy-to-clipboard', CopyToClipboard);
Vue.component('avl-chat', Chat);
Vue.component('avl-hamburger', Hamburger);
Vue.component('avl-sound-toggle', SoundToggle);
Vue.component('avl-password-input', PasswordInput);
Vue.component('avl-paypal-donation', PayPalDonation);
Vue.component('avl-player-avatar', PlayerAvatar);
Vue.component('avl-team-vote', TeamVote);
